import { create } from 'zustand';
import * as apiClient from '../lib/api';

const STORAGE_KEY = 'auralis_user';

function loadStoredUser() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export const useUserStore = create((set, get) => ({
  user: loadStoredUser(),
  isPremiumUser: false,
  draftDomainAnswers: {},
  unreadCount: 0,

  refreshUnread: async () => {
    const { user } = get();
    if (!user?.id || (user.role && user.role !== 'patient')) return;
    try {
      const [m, n] = await Promise.all([
        apiClient.getMessageUnreadCount(user.id).catch(() => ({ unread_count: 0 })),
        apiClient.getNotificationUnreadCount(user.id).catch(() => ({ unread_count: 0 })),
      ]);
      set({ unreadCount: (m.unread_count || 0) + (n.unread_count || 0) });
    } catch {
      /* ignore */
    }
  },

  setUser: (user) => {
    if (user) localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
    else localStorage.removeItem(STORAGE_KEY);
    set({ user });
  },

  logout: () => {
    localStorage.removeItem(STORAGE_KEY);
    set({ user: null, isPremiumUser: false });
  },

  refreshUser: async () => {
    const { user } = get();
    if (!user?.id) return;
    try {
      const fresh = await apiClient.getUser(user.id);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(fresh));
      set({ user: fresh });
    } catch (e) {
      /* ignore */
    }
  },

  checkPremiumStatus: async () => {
    const { user } = get();
    if (!user?.id) return;
    try {
      const sub = await apiClient.getSubscription(user.id);
      set({ isPremiumUser: !!sub });
    } catch {
      set({ isPremiumUser: false });
    }
  },

  setDraftDomainAnswers: (domain, answers) =>
    set((state) => ({
      draftDomainAnswers: { ...state.draftDomainAnswers, [domain]: answers },
    })),
  clearDraftDomainAnswers: (domain) =>
    set((state) => {
      const next = { ...state.draftDomainAnswers };
      delete next[domain];
      return { draftDomainAnswers: next };
    }),
}));

export function roleHome(role) {
  switch (role) {
    case 'superadmin':
      return '/superadmin';
    case 'admin':
      return '/admin';
    case 'clinician':
      return '/clinician';
    default:
      return '/app';
  }
}
